import localforage from "localforage";

const offlineDB = localforage.createInstance({
  name: "offlineDB",          // ชื่อ DB (เห็นใน DevTools)
  storeName: "assessments",   // table
  version: 1,
  description: "Offline Assessment Storage",
  driver: localforage.INDEXEDDB, // ❗ บังคับใช้ IndexedDB
});

export default offlineDB;
